'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiPlus = function TiPlus(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30 16.7h-6.7v-6.7c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3l0.1 6.7h-6.8c-1.8 0-3.3 1.5-3.3 3.3s1.5 3.3 3.3 3.3l6.8-0.1-0.1 6.8c0 1.8 1.5 3.3 3.3 3.3s3.3-1.5 3.3-3.3v-6.8l6.7 0.1c1.8 0 3.3-1.5 3.3-3.3s-1.5-3.3-3.3-3.3z' })
        )
    );
};

exports.default = TiPlus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/plus.js
// module id = 2150
// module chunks = 0